<template>
  <span class="ticker">
    <span v-for="seg in segments" :key="seg.k" class="ticker-seg">{{ seg.text }}</span>
  </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { acquireTelemetry, releaseTelemetry, TelemetryState } from '@/composables/useTelemetry';

export default defineComponent({
  name: 'NervTicker',
  data() {
    return {
      t: null as TelemetryState | null,
    };
  },
  computed: {
    segments(): Array<{ k: string; text: string }> {
      const t = this.t;
      if (!t) return [];
      const out: Array<{ k: string; text: string }> = [];
      if (t.fps > 0) out.push({ k: 'fps', text: `${t.fps} fps` });
      if (t.heapUsedMb !== null) out.push({ k: 'heap', text: `heap ${t.heapUsedMb.toFixed(1)} MB` });
      if (t.netType) {
        out.push({
          k: 'net',
          text: `link ${t.netType}${t.downlink !== null ? ` ${t.downlink.toFixed(1)} Mb/s` : ''}`,
        });
      } else if (!t.online) {
        out.push({ k: 'net', text: 'link offline' });
      }
      if (t.rtt !== null) out.push({ k: 'rtt', text: `rtt ${t.rtt} ms` });
      if (t.batteryLevel !== null) {
        out.push({ k: 'batt', text: `batt ${t.batteryLevel}%${t.batteryCharging ? ' chg' : ''}` });
      }
      out.push({ k: 'up', text: `t+ ${t.uptime}` });
      return out;
    },
  },
  mounted() {
    this.t = acquireTelemetry();
  },
  beforeUnmount() {
    releaseTelemetry();
  },
});
</script>

<style scoped>
.ticker {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: baseline;
  column-gap: 0;
  color: var(--text-faint);
  font-family: var(--font-nerv-mono);
  font-size: 0.62rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  font-variant-numeric: tabular-nums;
}

.ticker-seg + .ticker-seg::before {
  content: '/';
  margin-inline: 0.55rem;
  opacity: 0.45;
}
</style>
